import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-std-atd-settings',
  templateUrl: './std-atd-settings.component.html',
  styleUrls: ['./std-atd-settings.component.scss']
})
export class StdAtdSettingsComponent implements OnInit {
  StdAtdSetting: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  Table = false;
  APIService: any;
  StudentTable: [];
  colrChang = false;
  CountTable: [];
  StuArray: FormArray;
  dialogRef: MatDialogRef<any>;
  dialogRef1: MatDialogRef<any>;
  sessionList: any[];
  SessionFilterList: any[];
  sessionId = 0;
  CoCode = 0;
  CgCode = 0;
  CourseList: any;
  SaveBtn = false;
  UpdateBtn = false;
  BranchShow = false;
  saveDisable = false;
  updateDisable = false;
  filteredListCourse: any;
  collegeList: any;
  filteredCollegeList: any;
  CountTableForApp: any[];
  inteckCount: number;
  assignTableData: any[];
  Student: any;
  errMsg: any;
  currentDate: Date;
  Session: any;
  filteredListExam: any;
  ExamList: any;
  BranchList: any;
  filteredListBranch: any;
  emid: any;
  subjectList = []
  filteredsubjectList
  exsubjectData
  savedpayload: any;
  tableData: any;
  userPermission: any;
  UserCollege
  utp: string;
  AtdSettingCreate = true;
  AtdSettingUpdate = true;
  // jsonData: any;
  constructor(private dialog: MatDialog,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private spinner: NgxSpinnerService, public datepipe: DatePipe,

  ) { this.APIService = environment.serviceUrl; }


  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if(this.utp !== 'Super Admin' && this.utp !== 'Admin'){
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
      if(element.PageName == 'Subject Attendance' && element.PCreate == false)
      {
          this.AtdSettingCreate = false;  
      }
      if(element.PageName == 'Subject Attendance' && element.PUpdate == false)
      {
          this.AtdSettingUpdate = false;  
      }   
     
    });
  }
    this.SaveBtn = false;
    this.UpdateBtn = false;
    this.BranchShow = false;
    this.Table = false
    this.submitButton = true;
    this.editButton = false;
    this.saveDisable = false
    this.updateDisable = false
    this.StdAtdSetting = this.fb.group({
      CgCode: new FormControl(''),
      CoCode: new FormControl(''),
      EmId: new FormControl(''),
      StrId: new FormControl(0),
      SessionId: new FormControl(''),
      StuArray: new FormArray([]),
    });
    this.fetchSession('');
    this.currentDate = new Date();
    this.getCollegeData();
  }

  getStuArrayControls() {
    return (this.StdAtdSetting.get('StuArray') as FormArray).controls;
  }



  fetchSession(id) {
    this.Session = 0
    this.spinner.show();
    const payload = {};
    this.filteredListCourse = [];
    this.filteredCollegeList = [];
    payload['SnDefault'] = id;
    payload['SnNo'] = id;
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
    })
  }
  getCollegeData() {
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    this.spinner.show();
    const payload = {};
    payload['CgCode'] = this.UserCollege
    this.umsService.getCollege(payload).subscribe((res) => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredCollegeList = this.collegeList.slice();

    }, (ERROR: HttpErrorResponse) => {
      this.collegeList = [];
      this.spinner.hide();
    })
  }

  SetSession(data) {
    this.Session = data
    this.ExamList = [];
    this.CourseList = [];
    this.BranchList = [];
  }

  getCourse(data) {
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    this.StdAtdSetting.controls['CoCode'].setValue('');
    this.StdAtdSetting.controls['EmId'].setValue('');
    this.StdAtdSetting.controls['StrId'].setValue('');
    this.ExamList = [];
    this.BranchList = [];
    this.CourseList = [];
    this.Table = false;
    this.BranchShow = false;
    this.spinner.show();
    const payload = {};
    payload['CgCode'] = data;
    payload['SessionId'] = data;
    // getSessionColgCo
    this.umsService.getCourse(payload).subscribe((res) => {
      this.spinner.hide();
      this.CourseList = res.data;
      this.filteredListCourse = this.CourseList.slice();

    }, (ERROR: HttpErrorResponse) => {
      this.CourseList = [];
      this.spinner.hide();
    })
  }

  getExam(data) {
    this.Table = false;
    this.StdAtdSetting.controls['EmId'].setValue('');
    this.StdAtdSetting.controls['StrId'].setValue('');
    this.ExamList = [];
    this.BranchList = [];
    this.BranchShow = false;
    this.spinner.show();
    const payload = {};
    payload['EmCoCode'] = data;
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.ExamList = res.data;
        this.filteredListExam = this.ExamList.slice();
      }
      else {
        this.ExamList.data = [];
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
      // this.umsService.openSnackbar(ERROR.error.message);

    });
  }



  fetchBranch(data) {
    this.emid = data;
    const payload = {};
    payload['EmId'] = data;
    this.umsService.getExamStream(payload).subscribe(res => {
      if (res.status) {
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      }
    });
  }

  getExmSub(data) {
    this.StdAtdSetting.controls['StrId'].setValue('');
    this.BranchList = [];
    this.emid = 0;
    this.Table = false;
    if (data.EmStreams == "Y") {
      this.BranchShow = true;
      this.StdAtdSetting.controls['StrId'].setValue(0)
      this.fetchBranch(data.EmId);
      // this.emid = e.EmId;
    }

    else {
      this.StdAtdSetting.controls['StrId'].setValue(0)
      this.BranchShow = false;
      // 
      this.getAttendance(data.EmId, 0);

    }
  }


  getAttendance(emid, strid) {
    this.savedpayload = this.StdAtdSetting.value
    this.StuArray = this.StdAtdSetting.get('StuArray') as FormArray;
    this.StuArray.clear();
    const payload = {};
    payload['CgCode'] = this.savedpayload.CgCode;
    payload['CoCode'] = this.savedpayload.CoCode;
    payload['EmId'] = this.savedpayload.EmId;
    payload['StrId'] = this.savedpayload.StrId;
    payload['SessionId'] = this.savedpayload.SessionId;
    this.umsService.getStuAtdSet(payload).subscribe(res => {

      if (res.status) {
        this.Table = true;
        // Check if all Attendance values are null
        const isAllNull = res.data.every(item => item.Attendance === null);

        // Check if at least one Attendance has a numerical value
        const hasNumericalValue = res.data.some(item => typeof item.Attendance === 'number');

        // Set the flags for save and update buttons based on the conditions
        // const saveButton = 
        // const updateButton = 
        this.SaveBtn = isAllNull;;
        this.UpdateBtn = !isAllNull && hasNumericalValue;;

        res.data.forEach((element, i) => {
          const creds = this.StdAtdSetting.get('StuArray') as FormArray;
          creds.push(
            this.fb.group({
              SrNo: new FormControl(i + 1),
              EsCode: new FormControl(element.EsCode),
              EsName: new FormControl(element.EsName),
              EsId: new FormControl(element.EsId),
              Attendance: new FormControl(element.Attendance, [Validators.pattern('^(?:99|[0-9]{1,2})([.][0-9]{1,2})?$'), Validators.required]),
              AttSetId: new FormControl(element.AttSetId),
            })
          );
        });
      }
      else {
        // this.subjects(emid, strid)
      }



    });
  }

  subjects(EmId, StrId) {
    this.SaveBtn = true;
    this.UpdateBtn = false;
    this.StuArray = this.StdAtdSetting.get('StuArray') as FormArray;
    this.StuArray.clear();
    this.tableData = []
    const payload = {};
    payload['EsEmId'] = EmId;
    payload['EsStrId'] = StrId;
    payload['EsType'] = 'S'
    this.umsService.getSubjectList(payload).subscribe(res => {
      if(res.status){
        this.Table = true;
        this.tableData = res.data;
        this.tableData.forEach((element, i) => {
          const creds = this.StdAtdSetting.get('StuArray') as FormArray;
          creds.push(
            this.fb.group({
              SrNo: new FormControl(i + 1),
              EsCode: new FormControl(element.EsCode),
              EsName: new FormControl(element.EsName),
              EsId: new FormControl(element.EsId),
              Attendance: new FormControl('', [Validators.pattern('^(?:99|[0-9]{1,2})([.][0-9]{1,2})?$'), Validators.required]),
              AttSetId: new FormControl(''),
  
            })
          );
        });
  
      }
      else{
        this.Table = false;
        this.SaveBtn = false;
        this.UpdateBtn = false;
      }
      
    });
  }

  getBrSub(data) {
    this.getAttendance(this.emid, data);
  }

  addNewRow() {
    const creds = this.StdAtdSetting.controls.StuArray as FormArray;
    creds.push(
      this.fb.group({
        EsCode: new FormControl(''),
        EsName: new FormControl(''),
        Attendance: new FormControl('', [Validators.pattern('^(?:99|[0-9]{1,2})([.][0-9]{1,2})?$'), Validators.max(100),, Validators.required]),
        Status: new FormControl('N'),
        StuId: new FormControl(''),
        SctId: new FormControl(''),
        AttSetId: new FormControl('')
      })
    );
  }

  onInputChange2(val, i) {
    this.saveDisable = false
    this.updateDisable = false
    const tempData = val.target.value;
    let taskListArrays = this.StdAtdSetting.get('StuArray') as FormArray;
    if(tempData > 100){
        taskListArrays.controls[i].get('Attendance').setErrors({ PercentError: true });
      if(this.SaveBtn == true){
        this.saveDisable = true
      }
      else if(this.UpdateBtn == true){
        this.updateDisable = true
      }
    }
    else{
      taskListArrays.controls[i].get('Attendance').setErrors(null);
      if(this.SaveBtn == true){
        this.saveDisable = false
      }
      else if(this.UpdateBtn == true){
        this.updateDisable = false
      }
    }

    
    if (tempData >= 75) {
      this.StuArray = this.StdAtdSetting.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('Y');
    }
    else if (tempData < 75) {
      this.StuArray = this.StdAtdSetting.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('N');
    }
    else if (tempData == '') {
      this.StuArray = this.StdAtdSetting.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('Y');
    }

    if (/[^0-9]/.test(tempData)) {
      taskListArrays.controls[i].get('Attendance').setErrors({ NonNumericError: true });
      if(this.SaveBtn == true){
        this.saveDisable = true
      }
      else if(this.UpdateBtn == true){
        this.updateDisable = true
      }
    }
    else{
      taskListArrays.controls[i].get('Attendance').setErrors(null);
      if(this.SaveBtn == true){
        this.saveDisable = false
      }
      else if(this.UpdateBtn == true){
        this.updateDisable = false
      }
    }

    
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  errorcheckR(i) {
    return i.controls['Attendance'].touched && i.controls['Attendance'].errors?.pattern
  }

  LessThan(i) {
    return i.controls['Attendance'].touched && i.controls['Attendance'].errors?.max
  }

  Save(){
    if (this.StdAtdSetting.invalid) {
      this.StdAtdSetting.get('CoCode').markAsTouched();
      this.StdAtdSetting.get('SessionId').markAsTouched();
      this.StdAtdSetting.get('EmId').markAsTouched();
      this.StuArray = this.StdAtdSetting.get('StuArray') as FormArray;
      if (this.StuArray.invalid) {
        this.StuArray.controls.forEach(element => {
          element.get('Attendance').markAsTouched();
        })
        return
      }
      return
    }
    else {
      this.SaveAtd()
      return
    }
  }

  SaveAtd() {
    this.spinner.show();
    this.submitpayload = this.StdAtdSetting.value;
    this.StdAtdSetting.controls.StuArray as FormArray;
    this.StuArray = this.StdAtdSetting.get('StuArray') as FormArray;
    this.Student = this.StuArray.value
    // let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      this.Student.forEach((element, index, array) => {
        let payload = {};
        payload['SessionId'] = this.submitpayload['SessionId'];
        payload['CgCode'] = this.submitpayload['CgCode'];
        payload['CoCode'] = this.submitpayload['CoCode'];
        payload['EmId'] = this.submitpayload['EmId'];
        payload['StrId'] = this.submitpayload['StrId'];
        payload['Attendance'] = parseInt(element.Attendance);
        payload['EsId'] = parseInt(element.EsId);
        payload['EsName'] = element.EsName;
        payload['EsCode'] = element.EsCode;
        this.umsService.saveStuAtdSet(payload).subscribe(res => {
          this.spinner.hide();
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
          }
        }, (ERROR: HttpErrorResponse) => {
          iserror = true;
          this.errMsg = ERROR.error.message
          if (index === array.length - 1) resolve();
        });
      });
    })
    bar.then(() => {
      if (iserror == false) {
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          // this.ShowTable(this.submitpayload['college'])
          this.getAttendance(this.submitpayload['EmId'], this.submitpayload['StrId'])
        });

      } else {
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          // this.ShowTable(this.submitpayload['college'])
          this.getAttendance(this.submitpayload['EmId'], this.submitpayload['StrId'])
        });
      }
    });
  }

  update(){
    if (this.StdAtdSetting.invalid) {
      this.StdAtdSetting.get('CoCode').markAsTouched();
      this.StdAtdSetting.get('SessionId').markAsTouched();
      this.StdAtdSetting.get('EmId').markAsTouched();
      this.StuArray = this.StdAtdSetting.get('StuArray') as FormArray;
      if (this.StuArray.invalid) {
        this.StuArray.controls.forEach(element => {
          element.get('Attendance').markAsTouched();
        })
        return
      }
      return
    }
    else {
      this.updateAtd()
      return
    }
  }

  updateAtd() {

    this.spinner.show();
    this.submitpayload = this.StdAtdSetting.value;
    this.StdAtdSetting.controls.StuArray as FormArray;
    this.StuArray = this.StdAtdSetting.get('StuArray') as FormArray;
    this.Student = this.StuArray.value
    // let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      this.Student.forEach((element, index, array) => {
        let payload = {};
        payload['SessionId'] = this.submitpayload['SessionId'];
        payload['CgCode'] = this.submitpayload['CgCode'];
        payload['CoCode'] = this.submitpayload['CoCode'];
        payload['EmId'] = this.submitpayload['EmId'];
        payload['StrId'] = this.submitpayload['StrId'];
        payload['Attendance'] = parseInt(element.Attendance);
        payload['AttSetId'] = parseInt(element.AttSetId);
        payload['EsId'] = parseInt(element.EsId);
        payload['EsName'] = element.EsName;
        payload['EsCode'] = element.EsCode;
        if (isNaN(payload['AttSetId'])) {
          this.umsService.saveStuAtdSet(payload).subscribe(res => {
            this.spinner.hide();
            if (res.status == false) {
              iserror = true;
              this.errMsg = res.message
            }
            if (index === array.length - 1) resolve();
            else {
              iserror = false
              this.errMsg = res.message
            }
          }, (ERROR: HttpErrorResponse) => {
            iserror = true;
            this.errMsg = ERROR.error.message
            if (index === array.length - 1) resolve();
          });
        }
        else if (!isNaN(payload['AttSetId'])) {
          this.umsService.updateStuAtdSet(payload).subscribe(res => {
            this.spinner.hide();
            if (res.status == false) {
              iserror = true;
              this.errMsg = res.message
            }
            if (index === array.length - 1) resolve();
            else {
              iserror = false
              this.errMsg = res.message
            }
          }, (ERROR: HttpErrorResponse) => {
            iserror = true;
            this.errMsg = ERROR.error.message
            if (index === array.length - 1) resolve();
          });
        }
      
      });
    })
    bar.then(() => {
      if (iserror == false) {
        let data = {}
        data['message'] = "Updated Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          // this.ShowTable(this.submitpayload['college'])
          this.getAttendance(this.submitpayload['EmId'], this.submitpayload['StrId'])
        });

      } else {
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          // this.ShowTable(this.submitpayload['college'])
          this.getAttendance(this.submitpayload['EmId'], this.submitpayload['StrId'])
        });
      }
    });
  }
  getid(value){
    let id = value.controls.EsCode.value;
    return id;
  }
 
}
